import apiCall from 'apps/investment/apiCalls/stock-balance-histories';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';

export const InvestmentBalanceHistoriesListPage = () => (
  <ListPage
    title="Balance History"
    description="All Withdrawal/Deposit Requests"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => (
      <DynamicFilterForm fields={filterConfig} showSearchField={false} />
    )}
  />
);

export const InvestmentBalanceHistoriesDetailPage = () => (
  <DetailPage
    title="Request"
    apiCall={apiCall}
    listUrl={`/investment/stock-balance-histories`}
    ItemDetail={ItemDetail}
    options={{ editEnabled: false }}
  />
);
